import { render, staticRenderFns } from "./orders-comp.vue?vue&type=template&id=a3eb70cc&scoped=true"
var script = {}
import style0 from "./orders-comp.vue?vue&type=style&index=0&id=a3eb70cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3eb70cc",
  null
  
)

export default component.exports